import { render, staticRenderFns } from "./amountDispose.vue?vue&type=template&id=5e025f1c&scoped=true&"
import script from "./amountDispose.vue?vue&type=script&lang=js&"
export * from "./amountDispose.vue?vue&type=script&lang=js&"
import style0 from "./amountDispose.vue?vue&type=style&index=0&id=5e025f1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e025f1c",
  null
  
)

export default component.exports